import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PatientDetailsV2 } from '@ffd/api-client';
import { AvatarsComponent, HighlightDirective } from '@libs/ui-lib';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { Store } from '@ngrx/store';
import { selectUserSiteId } from '@libs/store';
import { routes } from '@libs/utils';
import { PatientToPersonPipe, PhoneFormatPipe } from '../../pipes';
import { PatientItemActionsComponent } from '../patient-item-actions';
import { PatientStatusComponent } from '../patient-status';

@Component({
  selector: 'lib-patient-item',
  templateUrl: './patient-item.component.html',
  styleUrls: ['./patient-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RouterModule,
    DatePipe,
    AvatarsComponent,
    PatientToPersonPipe,
    PatientStatusComponent,
    PatientItemActionsComponent,
    HighlightDirective,
    PhoneFormatPipe,
    SvgIconComponent,
  ],
})
export class PatientItemComponent {
  private readonly store = inject(Store);
  public readonly siteId = this.store.selectSignal(selectUserSiteId);

  public routes = routes;

  @Input() public patient!: PatientDetailsV2;
  @Input() public highlightedText: string | null | undefined = null;

  public get patientNameLabel(): string {
    return `${this.patient.firstName} <strong>${this.patient.lastName}</strong>`;
  }

  public toLocalDate(dateStr: string | undefined): Date | undefined {
    if (!dateStr) return undefined;
    const [y, m, d] = dateStr.split('-').map(Number);
    return new Date(y, m - 1, d); // local midnight
  }
}
